module.exports = __webpack_public_path__ + "static/media/wortmarke_smokeless.a59001fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/wortmarke_smokeless.svg
// module id = 280
// module chunks = 0